import React from 'react';
import LoadingComponent from '../loading-component';
import TranslatedCopy from '../../../intl/translated-copy';

const BillingLoader = ({
  loadingStampingBilling,
}) => {
  return (
    <div className='BillingLoader'>
      { loadingStampingBilling &&
        <div className='BillingLoader-textContainer'>
          <TranslatedCopy
            className='BillingLoader-textContainer--title'
            copyID='MYB_DO_NOT_CLOSE_THE_WINDOW'
          />
          <TranslatedCopy
            className='BillingLoader-textContainer--header'
            copyID='MYB_GENERATING_YOUR_INVOICE'
          />
        </div>
      }
      <LoadingComponent />
    </div>
  );
};

export default BillingLoader;